import { useQuery } from "@tanstack/react-query";
import serialsClient from "../../../api/serials";

const useSerialsBatches = () => {
  return useQuery({
    queryKey: ["serials", "batches"],
    queryFn: () => serialsClient.listBatches(),
  });
};

export default useSerialsBatches;
